import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import StatusPage from "./components/StatusPage";
import { SiteBootstrapError, preloadSiteData } from "./lib/api";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

const getBootErrorContent = (error: unknown) => {
  if (error instanceof SiteBootstrapError) {
    if (error.status === 404) {
      return {
        statusCode: 404,
        title: "Sitegegevens niet gevonden",
        description: "De benodigde sitegegevens ontbreken. Controleer of de data-bestanden correct op de server staan.",
      };
    }

    if (error.status === 503) {
      return {
        statusCode: 503,
        title: "Site tijdelijk niet beschikbaar",
        description: "Onze alpaca's staan klaar, maar de sitegegevens zijn nu even niet bereikbaar. Probeer het zo opnieuw.",
      };
    }

    return {
      statusCode: error.status || 500,
      title: "Sitegegevens konden niet worden geladen",
      description: error.message || "Er ging iets mis bij het laden van de site. Probeer het later opnieuw.",
    };
  }

  return {
    statusCode: 500,
    title: "Er ging iets mis",
    description: "Er ging iets mis bij het opstarten van de site. Probeer het later opnieuw.",
  };
};

const bootstrap = async () => {
  try {
    await preloadSiteData();
    root.render(<App />);
    requestAnimationFrame(() => {
      document.documentElement.setAttribute("data-app-rendered", "true");
    });
  } catch (error) {
    const content = getBootErrorContent(error);
    // Wrap in BrowserRouter because StatusPage uses Header/Footer which need Router context
    root.render(
      <BrowserRouter>
        <StatusPage
          statusCode={content.statusCode}
          title={content.title}
          description={content.description}
          seoTitle={`${content.statusCode} | Alpacaboerderij Dordrecht`}
          seoDescription={content.description}
        />
      </BrowserRouter>
    );
    requestAnimationFrame(() => {
      document.documentElement.setAttribute("data-app-rendered", "true");
    });
  }
};

bootstrap();
